module.exports = __webpack_public_path__ + "images/花筑村全景_08-5.jpg?v=74b84188";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_08-5.jpg
 ** module id = 104
 ** module chunks = 1 2
 **/